var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllpingsDecLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 36,
    viewBox: "0 0 39 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2L12.6348 13.6793L17.1745 8.68637L35.3965 28.7106",
    stroke: "#FF004F",
    strokeWidth: 3.33445,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4199 28.7104H36.5131V19.8091",
    stroke: "#FF004F",
    strokeWidth: 3.55682,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37109 21.5964V35.8423",
    stroke: "#010412",
    strokeWidth: 3.55682,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4629 18.0217V35.8431",
    stroke: "#010412",
    strokeWidth: 3.55682,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5527 23.3662V35.843",
    stroke: "#010412",
    strokeWidth: 3.55682,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllpingsDecLight);
export default __webpack_public_path__ + "static/media/allpings_dec_light.afe02577fa2f2233d4a4045570fce059.svg";
export { ForwardRef as ReactComponent };